import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-output-layout',
  templateUrl: './display-layout.component.html',
  styleUrls: ['./display-layout.component.scss'],
})
export class DisplayLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
